export const {
  REACT_APP_API_SCHEME: API_SCHEME,
  REACT_APP_API_HOST: API_HOST,
  REACT_APP_API_PATH: API_PATH,
  REACT_APP_SOCKETS_URL: SOCKETS_URL,
  NODE_ENV,
} = process.env;

export default process.env;
